module.exports = __webpack_public_path__ + "static/media/PLAYGROUND_BRANDMARK_WHITE.a4e0af56.svg";